import { findOne } from 'rcd-cpp-workspace/utils/array';
import * as React from 'react';
import { FilterProps } from '../filters';
import './primaryFilter.scss';
import { Op } from '../../../enums/Op';
import { parseCondition } from '../../../utils';
import { SchemaTypeahead } from '../../SchemaTypeahead/schemaTypeahead';

const OPTIONS = [Op.refIds];

type RefFilterProps = FilterProps & { inlineMenu?: boolean };

export const PrimaryRelationTypeFilter = ({
  filter,
  field,
  setFilter,
  opts,
  filters
}: RefFilterProps) => {
  const curFilter = filter; //findOne(filters, { field: filter.field });
  if (!opts) opts = OPTIONS;
  const { op, val } = parseCondition(curFilter.conditions, opts[0]);

  return (
    <div className="filter-box reference-filter tree-filter">
      <div>{field.name}&nbsp;</div>
      <div>
        <SchemaTypeahead
          inline
          flat
          isChecked={s => {
            return val?.length ? val?.includes(s?.props?.type) : false;
          }}
          excludeSchemas={null}
          onSelectSchema={s => {
            let updatedValues = [];
            if (val?.includes(s?.props?.type)) {
              updatedValues = val.filter(v => v != s?.props?.type);
            } else {
              updatedValues = [...(val || []), s?.props?.type];
            }
            setFilter(
              { ...curFilter, conditions: [{ [op]: updatedValues }] },
              true
            );
          }}
        ></SchemaTypeahead>
      </div>
    </div>
  );
};
